import {
  Avatar, Flexbox, Form, ListManager, PageHeader, Paginator, QuickFilter, Styles,
} from '@/components'
import { clinicalCareStatus, clinicalCareStatusClasses } from '@/constants/clinicalCares'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import { Link } from 'react-router-dom'
import FilterClinicalCares from '../../components/FilterClinicalCares'

function ClinicalCaresByUser({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByUser, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por usuário"
        subtitle="Quantidade de atendimentos clínicos solicitados por usuários do seu município"
        icon="fas fa-user"
        rightAction={() => <FilterClinicalCares />}
      />
      <QuickFilter
        initialValues={{ 'author.fullName_cont': '' }}
        title="Filtrar"
        renderForm={() => (
          <Flexbox.Column className="col-3 mt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="authorFullName">Nome do usuário</Form.Label>
              <Form.ValidationField
                name="['author.fullName_cont']"
                className="input-sm"
                id="authorFullName"
                autoComplete="none"
                placeholder="Fulano da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
        )}
      />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <div className="p-2 bg-gray s-rounded">
              <div className="text-small">
                <span>Quantidade total de usuários do município: </span>
                <b>{data?.totalUsers}</b>
              </div>
              <div className="text-small">
                <span>
                  Quantidade de usuários que já solicitaram atendimento clínico
                  pelo menos uma vez:&nbsp;
                </span>
                <b>{data?.count}</b>
              </div>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table className="table table-hover text-small">
                <thead>
                  <tr>
                    <th>Usuário</th>
                    {data.statusList.map((status) => (
                      <th key={status} className={`text-center ${clinicalCareStatusClasses[status] || ''}`}>
                        {clinicalCareStatus[status] || status}
                      </th>
                    ))}
                    <th className="text-right" width="1">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data.rows.map((item) => (
                    <tr key={item?.authorId || 'without-author'}>
                      <td>
                        {item?.authorId ? (
                          <Link to={`/app/petis-users/${item.authorId}`}>
                            <Avatar
                              avatarSize="sm"
                              className="mr-1"
                              name={item?.authorFullName}
                              photoURL={item?.authorAvatar}
                              alt="Imagem de usuário"
                            />
                            {item?.authorFullName}
                          </Link>
                        ) : 'Usuário não informado'}
                      </td>
                      {data.statusList.map((status) => (
                        <td key={status} className="text-center">{item[status] || 0}</td>
                      ))}
                      <td className="text-right">{item?.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="my-2">
              <Paginator paginatedList={data} />
            </div>
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByUser
